var Emitter = require("tiny-emitter");
const emitter = new Emitter();

export default emitter;
